import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { useToast, POSITION } from 'vue-toastification';
import LegalStuff from '@/components/LegalStuff.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'LegalStuffToasted',
    props: {
        policyName: null
    },
    setup(__props) {
        const props = __props;
        const toast = useToast();
        function showPolicy() {
            const toastContent = {
                component: LegalStuff,
                props: {
                    policyName: props.policyName,
                },
            };
            toast(toastContent, {
                closeOnClick: false,
                position: POSITION.TOP_LEFT,
                timeout: false,
                hideProgressBar: true,
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("span", {
                class: "legal-stuff-toasted",
                onClick: showPolicy
            }, [
                _renderSlot(_ctx.$slots, "default")
            ]));
        };
    }
});
